import { lastValueFrom, take, timer } from 'rxjs';

export class TimerUtil {
  static async sleep(millis: number) {
    await lastValueFrom(timer(millis).pipe(take(1)));
  }
}
